import React from 'react'
import { format } from 'date-fns'
import popup from '~/views/Popup/popup'

const DeferredSubscription = (props) => {
    const { subscription } = props;
    return (
      <section>
        <div className="title site-color">Subscription</div>
        <div className="detail">
          <div className="title site-color">Subscription Plan</div>
          <div className="main">
            <div className="key">{ subscription.subscriptionPlanInfo && subscription.subscriptionPlanInfo.name }</div>
            <div className="next-step">
            {`Schedule to be cancelled on: ${format(subscription.subscriptionInfo.subscriptionEndDate, 'MM-DD-YYYY')}`}
            </div>
          </div>
          <div className="buttons">
            <div className="button" onClick={ _ => popup.billingHistory() }>Billing History</div>
          </div>
        </div>
        <div className="clearfix"></div>
      </section>)
  }

export default DeferredSubscription
